import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import TableReport from '@componentes/TableReport';
import Table from './Table';
import Td from './Table/Td';

import IntlMessage from "../../../../../../helpers/intlMessage";

function ImpressaoNotificacoes({ lista }) {
  const laudoSelecionado = useSelector(
    state => state.relatorio.laudoSelecionado
  );

  return (
    <TableReport
      title= {<IntlMessage id = "dashboards.reports.criticalReportNotifications"/>}/* {`${laudoSelecionado.nrExame}`} */
      assinatura={<IntlMessage id = "dashboards.reports.subscriptionCRM"/>}
    >
      <tr style={{ border: 0 }}>
        <table style={{ marginBottom: '30px' }}>
          <tr>
            <td
              colSpan={'1'}
              style={{
                border: '#eee solid 1px',
                fontSize: '12px',
                verticalAlign: 'center',
                padding: '4px 12px',
              }}
            >
              <div>
                <strong><IntlMessage id = "dashboards.general.pacient"/></strong>
                <span style={{ marginLeft: '5px' }}>{laudoSelecionado.paciente}</span>
                {laudoSelecionado.pacienteNomeSocial && <div><strong><IntlMessage id = "dashboards.general.socialName"/></strong>
                  <span style={{ marginLeft: '5px' }}>{laudoSelecionado.pacienteNomeSocial}</span></div>}
              </div>
            </td>
            <Td title={<IntlMessage id = "dashboards.reports.doctor"/>} value={laudoSelecionado.medico} />
            <Td
              title={<IntlMessage id = "dashboards.general.urgent"/>}
              value={laudoSelecionado.urgente ? <IntlMessage id = "dashboards.examDetails.yes"/> : <IntlMessage id = "dashboards.examDetails.no"/>}
            />
          </tr>
          <tr>
            <Td title={<IntlMessage id = "dashboards.general.examNumber"/>} value={laudoSelecionado.nrExame} />
            <Td title={<IntlMessage id = "dashboards.examDetail.table.exam"/>} value={laudoSelecionado.exame} />
            <Td
              title={<IntlMessage id = "dashboards.reports.externalExamNumber"/>}
              value={laudoSelecionado.nrExameExterno}
            />
          </tr>
          <tr>
            <Td title={<IntlMessage id = "dashboards.reports.medicalRecord"/>} value={laudoSelecionado.prontuario} />
            <Td title={<IntlMessage id = "dashboards.disposalMaterials.table.request"/>} value={laudoSelecionado.pedido} />
            <Td title={<IntlMessage id = "general.materialArchiving.report"/>} value={laudoSelecionado.laudo} />
          </tr>
          <tr>
            <Td
              title={<IntlMessage id = "dashboards.reports.materialDeliveryDate"/>}
              value={laudoSelecionado.dataEntregaMaterial}
            />
            <Td title={<IntlMessage id = "dashboards.reports.dateRequest"/>} value={laudoSelecionado.dataPedido} />
            <Td
              title={<IntlMessage id = "dashboards.reports.expectedDeliveryDate"/>}
              value={laudoSelecionado.dataEntregaPrevista}
            />
          </tr>
        </table>
      </tr>
      {lista.map((item, i) => (
        <tr key={i} style={{ border: 0 }}>
          <td style={{ border: 0, padding: 0 }}>
            <Table item={item} />
          </td>
        </tr>
      ))}
    </TableReport>
  );
}

ImpressaoNotificacoes.propTypes = {
  lista: PropTypes.array.isRequired
};

ImpressaoNotificacoes.defaultProps = {
  lista: []
};

export default ImpressaoNotificacoes;



// WEBPACK FOOTER //
// ./src/pages/relatorio/LaudoCritico/Relatorios/Notificacao/Impressao/index.js